import { Info, AlertTriangle, AlertCircle } from 'lucide-react';
import { useStore } from '@/store';

/** Non-blocking toast notifications (P1.1.4). */
export function ToastHost() {
  const toasts = useStore((s) => s.toasts);
  const removeToast = useStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  const icons = {
    info: Info,
    warn: AlertTriangle,
    danger: AlertCircle,
  } as const;

  return (
    <div className="toast-host" role="status" aria-live="polite">
      {toasts.map((t) => {
        const Icon = icons[t.tone];
        return (
          <div key={t.id} className={`toast toast-${t.tone}`} role={t.tone === 'danger' ? 'alert' : 'status'}>
            <Icon size={16} className="toast-icon" aria-hidden="true" />
            <span className="toast-message">{t.message}</span>
            <button type="button" className="toast-close" aria-label="Dismiss" onClick={() => removeToast(t.id)}>
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
